import $ from 'jquery';
import { $doc, $win, $body } from '../utils/globals';

const burgerButton = $('#burger-button');
let forceClose = true;

$doc.on('click', '#burger-button', function(){
	$body.toggleClass('has-active-mobile-menu');
})

$win.on('resize', () => {
	const desktop = $win.width() > 1024;
	const isMenuActive = $body.is('.has-active-mobile-menu');

	if (desktop && isMenuActive) {
		if (forceClose) {
			forceClose = false;

			burgerButton.trigger('click')
		}
	} else {
		forceClose = true;
	}
});

$doc.on('click', '#js-trigger-login', function(event){
	event.preventDefault();
	const loginBtn = document.querySelector('.js-sim-login .btn')
	loginBtn.click();
	burgerButton.trigger('click');
})

$doc.on('click', '.js-click-login a, a.js-click-login', function(event){
	event.preventDefault();
	const loginBtn = document.querySelector('.js-sim-login .btn');
	if(loginBtn) {
		loginBtn.click();
	}
})